import type { IMenuSection } from "@fondationcss/ui";

const MAX_SIDEBAR_GROUPS = 10;

// Menu en sections (même style que parcours) : Élève, Enseignant, Planification,
// Gestion sont des SECTIONS (avec icône), et les pages réelles sont réparties dans
// la bonne section.
export const menus: IMenuSection[] = [
  {
    title: 'Élève',
    icon: 'user-graduate',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    permissions: ['Perspective.TimeLine.ManageOwn'],
    groups: [
      { title: 'Tableau de bord', icon: 'dashboard', to: '/lignedetemps/tableau-de-bord' },
      { title: 'Mes lignes de temps', icon: 'bars-staggered', to: '/lignedetemps/visualisateur' },
    ],
  },
  {
    title: 'Enseignant',
    icon: 'chalkboard-user',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    // Perspective.TimeLine.Manage (issue #95, portée par le rôle Intervenant) : gère les
    // lignes de temps ; le catalogue de cours relève de Perspective.Course.Manage.
    permissions: ['Perspective.TimeLine.View', 'Perspective.TimeLine.Manage'],
    groups: [
      // L'enseignant y choisit l'élève dont il veut voir les cours en cours.
      { title: 'Tableau de bord', icon: 'dashboard', to: '/lignedetemps/tableau-de-bord' },
      { title: 'Lignes de temps', icon: 'bars-staggered', to: '/lignedetemps/visualisateur' },
    ],
  },
  {
    title: 'Planification',
    icon: 'calendar',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    permissions: ['Core.Calendar.Manage', 'Perspective.Admissions.Reviewer', 'Perspective.FgaEnrollments.Read'],
    groups: [
      // Calendar v3 (#131) : le calendrier système n'existe plus — le lien mène à la liste.
      { title: 'Calendrier', icon: 'calendar', to: '/core/calendar', permissions: ['Core.Calendar.Manage'] },
      // Aligné sur le backend : les routes Admissions n'acceptent que Reviewer.
      { title: 'Demandes d\'admission', icon: 'inbox', to: '/admin/systeme/inscription', permissions: ['Perspective.Admissions.Reviewer'] },
      { title: 'Fréquentations FGA', icon: 'file-lines', to: '/admin/systeme/fga-frequentation', permissions: ['Perspective.FgaEnrollments.Read'] },
    ],
  },
  {
    title: 'Gestion',
    icon: 'sliders',
    iconOnly: true,
    maxGroups: MAX_SIDEBAR_GROUPS,
    // Core.Calendar.Manage y figure pour les Rapports : un gestionnaire de calendrier doit
    // atteindre la section, ne serait-ce que pour cette seule entrée. Core.Calendar.View n'y
    // est PAS — tous les rôles la détiennent, la section s'ouvrirait à tout le monde.
    permissions: ['Perspective.Course.Manage', 'Perspective.Sites.Manage', 'Perspective.Admissions.Reviewer', 'Core.Privacy.Administrateur', 'Core.Audit.Administrateur', 'Core.Audit.Consultation', 'Core.Calendar.Manage'],
    groups: [
      // Catalogue de cours : administré via /api/Course/* (Perspective.Course.Manage).
      { title: 'Cours', icon: 'users-gear', to: '/lignedetemps/parametres2', permissions: ['Perspective.Course.Manage'] },
      // Centres (M1b-1): the shared SiteManagement, guarded by Perspective.Sites.Manage.
      { title: 'Centres', icon: 'building', to: '/admin/centres', permissions: ['Perspective.Sites.Manage'] },
      // Fondation's schedule pattern pages: routed by Fondation, reachable from no menu until now.
      { title: "Patrons d'horaire", icon: 'clock', to: '/core/schedule-patterns', permissions: ['Core.Calendar.Manage'] },
      { title: 'Inscription', icon: 'file-signature', to: '/admin/systeme/inscription-config', permissions: ['Perspective.Admissions.Reviewer'] },
      { title: 'Confidentialité', icon: 'shield-halved', to: '/admin/systeme/privacy', permissions: ['Core.Privacy.Administrateur'] },
      { title: "Journal d'audit", icon: 'clipboard-list', to: '/admin/systeme/audit', permissions: ['Core.Audit.Administrateur', 'Core.Audit.Consultation'] },
      { title: 'Importer/Exporter', icon: 'download', to: '/admin/import-export', permissions: ['Perspective.Course.Manage'] },
      // Rapports PDF. Cible du bouton « Imprimer en PDF » du calendrier, d'où la même
      // permission que l'entrée Calendrier.
      { title: 'Rapports', icon: 'file-lines', to: '/admin/rapports', permissions: ['Core.Calendar.Manage'] },
    ],
  },
];
